<div class="container-fluid">
  <div class="row section1">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">Create New NFT Collection</h5>
        <p class="home-subtitle">Add Collection details to create listing</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage">
        <div><a routerLink="/nfts-collection"><button class="btn btn-primary btn-dashboard">Back</button></a></div>
      </div>
    </div>
  </div>
  <div class="section1">
    @if (isCollectionCreated) {
      <div class="alert alert-success alert-dismissible fade show" style="margin:10px 0"
        role="alert"> New Entity {{collection.title}} Created
      </div>
    }
    @if (isError) {
      <div class="alert alert-danger alert-dismissible fade show" style="margin:10px 0;cursor: pointer;"
        role="alert">
        <span>{{errMessage}}</span>
      </div>
    }
    <div class="applicants-details details1">
      <form class="admin-form" enctype="multipart/form-data">
        <!--        <div class="row">-->
        <!--          <div class="col-12 col-lg-9 col-xl-9 job-form">-->
        <!--            <div class="row">-->

        <!--              <div class="col-12 col-lg-3 col-xl-3 form-details1">-->
        <!--                <div class="user-form">-->
        <!--                  <div class="form-group">-->
        <!--                    <label for="c-title">Collection Title*</label>-->
        <!--                    <input type="text" class="form-control" required id="c-title" name="c-title "-->
        <!--                           [(ngModel)]="collection.title" placeholder="Enter Title">-->
      <!--                  </div>-->
    <!--                </div>-->
  <!--              </div>-->

  <!--              <div class="col-12 col-lg-3 col-xl-3 form-details1">-->
  <!--                <div class="user-form">-->
  <!--                  <div class="form-group">-->
  <!--                    <label for="c-description">Description*</label>-->
  <!--                    <textarea type="text" class="form-control" required id="c-description" name="entity-label"-->
<!--                           [(ngModel)]="collection.description" placeholder="Enter Description"></textarea>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="col-12 col-lg-3 col-xl-3 form-details1">-->
<!--                <div class="user-form">-->
<!--                  <div class="form-group">-->
<!--                    <label for="e-category">Entity Category*</label>-->
<!--                    <select id="e-category" class="form-control" #category name="e-category"-->
<!--                            (change)="categoryChange(category.value)">-->
<!--                      <option selected>Select Category</option>-->
<!--                      <option *ngFor="let category of categoryList" [value]="category.id">-->
<!--                        {{category.categoryName}}</option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="col-12 col-lg-3 col-xl-3 form-details1">-->
<!--                <div class="user-form">-->
<!--                  <div class="form-group">-->
<!--                    <label for="e-category">Entity*</label>-->
<!--                    <select id="entity" class="form-control" #category name="entity"-->
<!--                            (change)="categoryChange(category.value)">-->
<!--                      <option selected>Select Category</option>-->
<!--                      <option *ngFor="let category of categoryList" [value]="category.id">-->
<!--                        {{category.categoryName}}</option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="col-12 col-lg-3 col-xl-3 form-details1">-->
<!--                <div class="user-form">-->
<!--                  <div class="form-group">-->
<!--                    <label for="profile">Choose Profile*</label>-->
<!--                    <input type="file" (change)="fileChangeEvent($event)" class="form-control" required-->
<!--                           id="profile" name="profile">-->
<!--                    &lt;!&ndash; <input type="file" (change)="pickImage($event)" class="form-control" required id="profile"-->
<!--                      name="profile"> &ndash;&gt;-->

<!--                    <image-cropper [imageChangedEvent]="imageChangedEvent" format="png"-->
<!--                                   (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"-->
<!--                                   (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()"-->
<!--                                   [cropperStaticWidth]="200" [cropperStaticHeight]="180"></image-cropper>-->

<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-12 col-lg-3 col-xl-3 form-details1"-->
<!--                   *ngFor="let sub of subjects; let i = index;">-->
<!--                <div class="user-form">-->
<!--                  <div class="form-group">-->
<!--                    <label>{{sub.fieldName}}</label>-->
<!--                    <div [ngSwitch]="sub.fieldType">-->
<!--                      <div *ngSwitchCase="'text'">-->
<!--                        <input type="text" class="form-control" [name]="sub.id"-->
<!--                               [(ngModel)]="informativeParameters[i]" [required]="sub.isRequired" [id]="sub.id"-->
<!--                               [placeholder]="sub.fieldName">-->
<!--                      </div>-->
<!--                      <div *ngSwitchCase="'date'">-->
<!--                        <input type="date" class="form-control" [name]="sub.id" [required]="sub.isRequired"-->
<!--                               [(ngModel)]="informativeParameters[i]" [id]="sub.id" [placeholder]="sub.fieldName">-->
<!--                      </div>-->
<!--                      <div *ngSwitchCase="'text-area'">-->
<!--                        &lt;!&ndash; <textarea class="form-control" [name]="sub.id" rows="6"-->
<!--                          [(ngModel)]="informativeParameters[i]" [required]="sub.isRequired" [id]="sub.id"-->
<!--                          [placeholder]="sub.fieldName"></textarea> &ndash;&gt;-->
<!--                        <angular-editor [placeholder]="sub.fieldName" [config]="editorConfig" rows="6"-->
<!--                                        [name]="sub.id" [(ngModel)]="informativeParameters[i]" [required]="sub.isRequired"-->
<!--                                        [id]="sub.id">-->
<!--                        </angular-editor>-->

<!--                      </div>-->
<!--                      <div *ngSwitchCase="'select'">-->
<!--                        <select [id]="sub.id" [name]="sub.id" [(ngModel)]="informativeParameters[i]"-->
<!--                                class="form-control">-->
<!--                          &lt;!&ndash; Implement on change here &ndash;&gt;-->
<!--                          <option selected>&#45;&#45;select&#45;&#45;</option>-->
<!--                          <option *ngFor="let category of categoryList" [value]="category.id">-->
<!--                            {{category.categoryName}}</option>-->
<!--                        </select>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <hr>-->
<!--        <app-politician-content *ngIf="isCollectionCreated && isPolitician" [entityId]="entityId"-->
<!--                                [politician]="politician"></app-politician-content>-->
<!--        <hr>-->
<!--        <div *ngIf="isCollectionCreated">-->
<!--          <h5 class="home-title">Subjective Parameters</h5>-->
<!--          <div class="col">-->
<!--            <div class="col-12 col-lg-3 col-xl-3 form-details1"-->
<!--                 *ngFor="let sub of subjectiveParameters; let i = index;">-->
<!--              <div class="user-form">-->
<!--                <div class="form-group">-->
<!--                  <label>{{sub.fieldName}}</label>-->
<!--                  <angular-editor [placeholder]="sub.fieldName" [config]="editorConfig" [name]="sub.id"-->
<!--                                  [(ngModel)]="subjectiveData[i]" [id]="sub.id">-->
<!--                  </angular-editor>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-6 col-md-6 col-lg-2 col-xl-2">-->
<!--              <div class="user-form">-->
<!--                <div class="form-group">-->
<!--                  <label for="candidate-name" style="color: #fff;">*</label>-->
<!--                  <div><button class="btn btn-primary btn-deshboard" (click)="addSubjectiveData()">Save Data-->
<!--                  </button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
@if (!isCollectionCreated) {
  <div (click)="createCollection()">
    <input type="submit" class="btn btn-primary btn-deshboard" value="Save Entity details">
  </div>
}
</form>
</div>
</div>
</div>
